import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Properties from "@/pages/Properties";
import CalendarPage from "@/pages/Calendar";
import Bookings from "@/pages/Bookings";
import Guests from "@/pages/Guests";
import Inquiries from "@/pages/Inquiries";
import PublicHome from "@/pages/public/PublicHome";
import VillaDetail from "@/pages/public/VillaDetail";

const Page = ({ children }) => (
  <ProtectedRoute>
    <Layout>{children}</Layout>
  </ProtectedRoute>
);

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors />
          <Routes>
            <Route path="/" element={<PublicHome />} />
            <Route path="/villa/:id" element={<VillaDetail />} />
            <Route path="/login" element={<Login />} />
            <Route path="/admin" element={<Page><Dashboard /></Page>} />
            <Route path="/admin/properties" element={<Page><Properties /></Page>} />
            <Route path="/admin/calendar" element={<Page><CalendarPage /></Page>} />
            <Route path="/admin/bookings" element={<Page><Bookings /></Page>} />
            <Route path="/admin/guests" element={<Page><Guests /></Page>} />
            <Route path="/admin/inquiries" element={<Page><Inquiries /></Page>} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
